<template>
  <div class="container">
    <form action="" style="width: 100%">
      <div class="row mt-3">
        <div class="col-xl-6">
          <textarea v-focus v-model="message" class="feedback_textarea" name="message" id="message"
            placeholder="Текст сообщения"> </textarea>
        </div>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-xl-6">
          <!-- <el-checkbox v-model="iAgree">Согласен на получение писем и звонков от сотрудников Компании</el-checkbox> -->
          <div class="float-right">
            <b-form-checkbox id="checkbox-1" v-model="iAgree" name="checkbox-1" disabled>
              {{ $t('Согласен на получение писем и звонков от Компании') }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-6">
          <div class="add_file_block" @click="infoOn = !infoOn" style="width: fit-content">
            <img src="../assets/imgs/clip1.svg" alt="" class="add_file" />
            <span style="color: #32aaa7; position: relative; top: 0px; font-size: 15px">Инструкция по отправке
              файлов</span>
            <img src="../assets/imgs/arrow_left.svg" alt="" :class="`add_file_arrow ${infoOn ? 'open' : ''}`" />
          </div>
          <div class="add_file_info" v-show="infoOn">
            <ul>
              <li>Если хотите отравить картинку (например, скриншот):</li>
              <li>1. Загрузите файл на любой хостинг картинок</li>
              <li>2. Создайте ссылку на файл</li>
              <li>3. Скопируйте ссылку на файл в текст сообщения</li>
              <div>
                <strong>Пример хостинга файлов</strong>: <br />
                <a href="https://printskrin.ru/" target="_blank" style="color: #32aaa7">PrintSkrin</a> <br />
                <a href="https://yandex.ru/support/disk/share/sharing.html" target="_blank"
                  style="color: #32aaa7">Яндекс. Диск</a>
              </div>
            </ul>
          </div>
        </div>
        <div class="col-xl-3 col-6">
          <button :class="[`btn_type_1`, message || 'disabled']" :disabled="!message"
            @click.prevent="sendFeedbackMessage">Отправить сообщение</button>
        </div>
      </div>
    </form>
    <b-modal id="bv-modal-send" hide-footer centered :hide-header-close="true" :no-close-on-backdrop="true">
      <div class="d-block text-center">
        <h3>
          {{ $t('Отправка сообщения') }}
        </h3>
        <p>{{ $t("Пожалуйста подождите") }}...</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import backAPI from '../assets/backApi';

export default {
  name: 'FeedbackForm',
  data() {
    return {
      message: '',
      infoOn: false,
      iAgree: true,
      userEmail: '',
    };
  },
  metaInfo() {
    this.setPageTitle(`${this.$t('Связаться с поддержкой')}`);
    return {
      title: `${this.$t('ЛК Партнёра')} - ${this.$t('Связаться с поддержкой')}`,
    };
  },
  mounted() {
    backAPI.get('agent/profile').then(Response => {
      this.userEmail = Response.data.email;
    });
  },
  methods: {
    ...mapActions('currentPage', ['setPageTitle']),
    async sendFeedbackMessage() {
      if (this.message === '') {
        this.showToast('Внимание!', 'Собщение не может быть пустым', 'danger');
        return;
      }
      console.log();
      if (this.userEmail === '' || this.userEmail === null) {
        this.showToast('Внимание!', 'Сообщение не может быть отправлено, так как у Вас не заполнен E-mail', 'danger');
        return;
      }
      const res = await this.createMessageBox('Вы уверены, что хотите отправить сообщение?');
      if (res) {
        this.$bvModal.show('bv-modal-send');
        backAPI.post('/agent/feedback', { message: this.message }).then(() => {
          this.$bvModal.hide('bv-modal-send');
          this.createMessageBoxError('Сообщение успешно отправлено');
          this.message = '';
        }).catch(error => {
          this.$bvModal.hide('bv-modal-send');
          this.createMessageBoxError(error.response.data.detail);
        });
      }
    },
    createMessageBox(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [h('h3', { class: ['text-center'] }, [messageText])]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        buttonSize: 'md',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'Да',
        size: 'xl',
      });
    },
    createMessageBoxError(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [h('h5', { class: ['text-center'], domProps: { innerHTML: messageText } })]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxOk([messageVNode], {
        buttonSize: 'md',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'OK',
        size: 'md',
      });
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' }, title),
        ],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
  },
  directives: {
    focus: {
      inserted: el => {
        el.focus();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.add_file_block {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.add_file_arrow {
  transform: rotate(90deg);
  position: relative;
  top: 2px;
  margin-left: 20px;

  &.open {
    transform: rotate(270deg);
  }
}

.feedback_textarea {
  width: 100%;
  padding: 10px;
  resize: none;
  height: 200px;
}

.add_file {
  width: 30px;
  height: 30px;
  margin-left: 0px;
}

.add_file_info {
  margin-top: 10px;

  ul {
    margin-left: 6px;

    li {
      font-size: 16px;
    }
  }
}

.btn_type_1 {
  margin-top: 0;
}
</style>
<style>
.el-collapse-item__arrow {}
</style>
